import './component';
import './config';
import './preview';

Shopware.Service('cmsService').registerCmsElement({
    name: 'acris-faq-single',
    label: 'acris-faq.elements.faqSingle.label',
    component: 'sw-cms-el-acris-faq-single',
    configComponent: 'sw-cms-el-config-acris-faq-single',
    previewComponent: 'sw-cms-el-preview-acris-faq-single',
    defaultConfig: {
        faqs: {
            source: 'static',
            value: []
        }
    }
});
